<template>
    <div>
        <div class="modal-header py-0 d-flex flex-column crm-modal-header">
            <div class="row w-100">
                <div class="col-12 pt-3 pb-1 pr-0 d-flex justify-content-center align-items-center dNone">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{this.isEditMode?$ml.get("EDIT_PERSON"):$ml.get("ADD_PERSON")}}</h5>
                    <button type="button" @click="closeButton"  class="close "  aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                    </button>
                </div>
            </div>
            <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="deal-tab" data-toggle="tab" href="#contact"  role="tab" aria-controls="contact" aria-selected="true">{{$ml.get('DETAIL_PERSON')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="customField-tab" data-toggle="tab" href="#customField" role="tab" aria-controls="customField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="file-tab" @click="watchUpdated=watchUpdated+1" data-toggle="tab" href="#file" role="tab" aria-controls="file" aria-selected="false">{{$ml.get('FILE')}}</a>
                </li>
            </ul>
            <button type="button" class="close d-none" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
            </button>
        </div>
        <div class="modal-body pt-10 pb-2 px-md-4 crm-modal-body">
            <div class="tab-content">
                <div class="tab-pane fade show active py-2" id="contact"  role="tabpanel" aria-labelledby="contact-tab">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('NAME')}}*</label>
                                    <input type="text" v-model="setContact['n']" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('SURNAME')}}</label>
                                    <input type="text" v-model="setContact['sn']" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('TCK')}}</label>
                                    <input type="number" onwheel="this.blur()" v-model="setContact['tck']" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                  <label class="new-label">{{$ml.get('E_MAIL')}}</label>
                                    <div class="w-100 position-relative">
                                      <input type="text" onwheel="this.blur()" v-model="setContact['email']" v-on:keyup.enter="addArray('emailAddresses',setContact['email']),setContact['email']=''" class="new-input">
                                      <i class="fa fa-plus h40 input-plus-absolute-right"
                                    @click="addArray('emailAddresses',setContact['email']),setContact['email']=''" ></i>
                                   </div>
                                   <div v-if="emailAddressesArray!==undefined">
                                        <ul class="mt-2 p-0" v-if="emailAddressesArray.length>0">
                                            <li type="button" v-for="i in emailAddressesArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                            <span class="float-left" >{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem('emailAddresses', i)"><span aria-hidden="true">&times;</span></span>
                                            </li>
                                        </ul>
                                   </div>
                                   <div v-else>
                                        <ul class="mt-2 p-0" v-if="undefinedEmailAddressesArray.length>0">
                                            <li type="button" v-for="i in undefinedEmailAddressesArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                            <span class="float-left" >{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItemUn('emailAddresses', i)"><span aria-hidden="true">&times;</span></span>
                                            </li>
                                        </ul> 
                                    </div>  
                                         
                                 </div>
                               </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">Gsm</label>
                                    <div class="w-100 position-relative">
                                        <input type="number" onwheel="this.blur()" v-model="setContact['gsm']" v-on:keyup.enter="addArray('gsmNumbers',setContact['gsm']),setContact['gsm']=''" class="new-input">
                                        <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" @click="addArray('gsmNumbers',setContact['gsm']),setContact['gsm']=''"></i>
                                    </div>
                                     <div v-if="gsmNumbersArray!==undefined">
                                            <ul class="mt-2 p-0" v-if="gsmNumbersArray.length>0">
                                                <li type="button" v-for="i in gsmNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem('gsmNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else>
                                            <ul class="mt-2 p-0" v-if="undefinedGsmNumbersArray.length>0">
                                                <li type="button" v-for="i in undefinedGsmNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItemUn('gsmNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>             
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                   <label class="new-label">{{$ml.get('LANDLINE')}}</label>
                                     <div class="w-100 position-relative">
                                     <input type="number" onwheel="this.blur()" v-model="setContact['phone']"  v-on:keyup.enter="addArray('phoneNumbers',setContact['phone']),setContact['phone']=''" class="new-input">
                                    <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" 
                                    @click="addArray('phoneNumbers', setContact['phone']),setContact['phone']=''"></i>
                                    </div>
                                       <div v-if="phoneNumbersArray!==undefined">
                                            <ul class="mt-2 p-0" v-if="phoneNumbersArray.length>0">
                                                <li type="button" v-for="i in phoneNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem('phoneNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else>
                                            <ul class="mt-2 p-0" v-if="undefinedPhoneNumbersArray.length>0">
                                                <li type="button" v-for="i in undefinedPhoneNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItemUn('phoneNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('FAX')}}</label>
                                      <div class="w-100 position-relative">
                                       <input type="number" onwheel="this.blur()" v-model="setContact ['fax']"  v-on:keyup.enter="addArray('faxNumbers',setContact['fax']),setContact['fax']=''" class="new-input">
                                        <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" @click="addArray('faxNumbers', setContact['fax']),setContact['fax']=''"></i>
                                         </div>
                                        <div v-if="faxNumbersArray!==undefined">
                                            <ul class="mt-2 p-0" v-if="faxNumbersArray.length>0">
                                                <li type="button" v-for="i in faxNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem('faxNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else>
                                            <ul class="mt-2 p-0" v-if="undefinedFaxNumbersArray.length>0">
                                                <li type="button" v-for="i in undefinedFaxNumbersArray" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItemUn('faxNumbers', i)"><span aria-hidden="true">&times;</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                         
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-12">                        
                                    <label class="new-label">{{$ml.get('JOBTITLE')}}</label>
                                    <input type="text" v-model="setContact['jobTitle']" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="position-relative m-0">
                                        <label class="new-label">{{$ml.get('RELATED_COMPANY')}}</label>
                                        <input type="text" v-model="organizationKeyword" class="new-input">
                                        <ul class="new-dropdown p-0 autocomplete-results" v-show="items.length>0">
                                            <li class="autocomplete-result" v-show='isHiddenOrganization' v-for='(result, i) in items' :key="i" @click="setResult(result)">{{result.name}}</li>
                                        </ul>
                                        <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenOrganization">  
                                            <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_COMPANY')}}</li>
                                            <li class="autocomplete-result f-w-normal font-family-bold f-14" @click="addOrg=true,isHiddenOrganization=false"> {{$ml.get('ADD_COMPANY')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                        </ul>
                                    </div>
                                    <div v-show="addOrg" class="col-12">
                                        <div class="row addContact">
                                            <div class="col-12 d-flex justify-content-between align-items-center fastAdd pt-2">
                                                <label class="font-m h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_COMPANY')}}</label>
                                                <span class="fa fa-close font-m cursor-pointer" @click="closeOrgButton" ></span>
                                            </div>
                                            <div class="col-12 crmButonGroupsType">
                                                <label class="new-label">{{$ml.get('TYPE_COMPANY')}}*</label>
                                                <div class=" btn-group  h-36">
                                                    <!-- <v-select :options="customerType" :reduce="label => label.value" label="label" v-model="addOrgArray['isCandidate']" :searchable="false"/> -->
                                                    <button class="btn btn-click h40" @click="addOrgArray['isCandidate']=true" :class="{active:addOrgArray['isCandidate']==true}" :disabled="isEditMode" style="border-radius:4px 0px 0px 4px">{{$ml.get('LEAD')}}</button>
                                                    <button class="btn btn-click h40" @click="addOrgArray['isCandidate']=false" :class="{active:addOrgArray['isCandidate']==false}" :disabled="isEditMode " >{{$ml.get('CUSTOMER')}}</button> 
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('NAME')}} * </label>
                                                <input type="text" v-model="addOrgArray['name']" :placeholder="addOrgArray['name']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('PHONE')}}</label>
                                                <input type="number" onwheel="this.blur()" v-model="addOrgArray['phone']"  class="new-input">
                                            </div>
                                            <div class="col-12 organizationBtnStyle my-3">
                                                <button @click="saveOrgButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                <button @click="closeOrgButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ADDRESS')}}</label>
                                    <textarea type="text" v-model="setContact['addr']" class="new-textarea"></textarea>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('COUNTRY')}}</label>
                                    <CountrySelect v-model="country" :placeholder="$ml.get('COUNTRY')" :countryName="true"  :country="country" @changeCountry="changeCountry" topCountry="TR" class="new-select bg-white light-gray-color"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('CITY')}}</label>
                                    <RegionSelect v-model="city" @input="changeCity" :country="country" :regionName="true" :countryName="true" :placeholder="$ml.get('CITY')" :region="city" class="new-select bg-white light-gray-color"/>
                                </div>
                            </div>
                            <div class="row" v-if="isTurkeyCountry || setContact['town']">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('DISTRICT')}} </label>
                                    <select v-model="setContact['town']" class="new-select bg-white light-gray-color">
                                        <option :value="town" v-for="(town,index) in townList[city]">{{town}}</option> 
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade py-2" id="customField" role="tabpanel" aria-labelledby="customField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" :edit="isEditMode" :editArray="customFieldsData"   postField="contact" :user="user" @updateData="$emit('updateData')" @returnCustomData="returnCustomData($event)" :users="users" @returnCustomField="returnCustomField=$event" :customField="customFieldArray" :allcustomFieldArray="customFieldArray"></special-area>
                    </div>
                </div>
                <div class="tab-pane fade py-2" id="file" role="tabpanel" aria-labelledby="file-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <file   :watchUpdated="watchUpdated"
                                :contactData='data'
                                :customerFiles="customerFiles"
                                @showCustomerFile="showCustomerFile($event)"
                                @addNewFile="addNewFile($event)"
                                @deleteFile="function($event){ 
                                    for(k in this.customerFiles){
                                    if(this.customerFiles[k]['oid']==$event['oid']){
                                        this.customerFiles.splice(k,1)
                                    }
                                }}"
                        ></file>
                    </div>
                </div>
            </div>
       
        </div>
        <div class="row crm-modal-footer stickyBtn m-0">
            <hr class="col-12 p-0 d-none mt-0 d-md-none ">
            <div class="col-12 dealBtnStyle py-3" v-if="isEditMode===false">
                <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('SAVE')}}</button>
                <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
            </div>
            <div class="col-12 dealBtnStyle py-3" v-if="isEditMode">
                <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('EDIT')}}</button>
                <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>                
            </div>
        </div>

        <!-- Değişiklik uyarısı Modal -->
        <div class="modal fade h-100" id="changeAlertModalContact" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white" >
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal" @click="changeAlertModalCancel">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="saveButton">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import axios from 'axios'
import _ from 'underscore'
import specialArea from '@/components/customField'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'
import File from './file.vue'
export default {
    name: 'newContact',
    props:["customFieldArray","user","users","updateData","data","isEditMode","pageIs","clearModal"],
    components:{
        'special-area':specialArea,
        CountrySelect,
        RegionSelect,
        File
    },
    data () {
        return {
            customFieldsData:{},
            setContact:{
                isCandidate:true,
                name:"",
                contacts:[],
                webAddr:"",
              //  taxOffice:"",
              //  taxNo:"",
                addr:"",
                country:"",
                city:"",
                town:"",
             //   postalCode:"",
                x:true,
                status:true,
                phone:"",
                gsm:"",
                email:"",
                fax:""
            },
            gsmNumbersArray:[],
            undefinedGsmNumbersArray:[],
            phoneNumbersArray:[],
            undefinedPhoneNumbersArray:[],
            faxNumbersArray:[],
            undefinedFaxNumbersArray:[],
            emailAddressesArray:[],
            undefinedEmailAddressesArray:[],
            contactId:"",
            organizationKeyword:"",
            organizationId:"",
            returnCustomField:[],
            isHiddenOrganization:false,
            items:[],
            organizations:[],
            city:"",
            country:"",
            jobTitle:"",
            isTurkeyCountry:false,
            name:"",
            surname:"",
            tck:"",
            
            customerType:[
                {value: true, label: this.$ml.get('LEAD')},
                {value: false, label: this.$ml.get('CUSTOMER')},
            ],
            addOrg:false,
            addOrgArray:{'isCandidate':true},
            watchUpdated:0,
            customerFiles:[]
        }
    },
    computed: {
        ...mapState([
            'cityList',
            'townList',
            'countryList',
            'baseUrl'
        ]),
         
    },
    methods:{
        changeCity(){
            this.setContact["town"]=""
        },
       
        returnCustomData(data){
             this.customFieldsData=data
              this.dataFilling(data)
            // this.setInputData(data)
        },
        setResult(result){
            this.organizationKeyword=result.name
            this.isHiddenOrganization = false
            this.organizationId=result._id.$oid
            this.selectOrganization=result.name
            this.organizations=[]
            let obj={}
            obj["$oid"]=this.organizationId
            this.organizations.push(obj)
            this.items=[]
        },
        saveOrgButton(){
            let url =""
            let obj ={}
            let dataObj={}
            let phone=[]
            if(this.addOrgArray['name'].length>1){
                obj["name"]=this.addOrgArray['name']
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: 'Firma adı boş olamaz!',
                })
                return false
            }
            if(this.addOrgArray['phone'].length>9){
                phone.push(this.addOrgArray['phone'])
                obj["phoneNumbers"] = phone
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARPHONE_COMPANY_LEAST_10_DIGITSNING'),
                })
                return false
            }
            obj["isCandidate"]=this.addOrgArray['isCandidate']
            obj["status"]=true
            url = "addOrganization"
            dataObj["organizationInputObj"]=obj
            this.postOrganization(url,dataObj)
        },
        postOrganization(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('NEW_COMPANY_ADDED'),
                        text: res.data.status.desc 
                    })
                    this.addOrgArray['phone']=""
                    this.addOrg=false
                    this.isNewOrganization=true
                    this.organizationKeyword=res.data.content.organization.name
                    this.isHiddenOrganization= false
                    this.organizationId=res.data.content.organization._id.$oid
                    this.selectOrganization=res.data.content.organization.name
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        closeOrgButton(){
            this.addOrg=false
            this.addContact=false
            this.addOrgArray['phone']=""
            this.isHiddenContact=false
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(re.test(email)===false){
                this.$notify({ group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('INVALID_EMAIL'),
                    text: this.$ml.get('PLEASE_INSERT_A_VALID_EMAIL')
                })
                return false
            }else{
                return email
            }
        },
        addArray(array,value){
             if(value!="" && value!=undefined){
                if(array=="emailAddresses"){
                
                    if(this.emailAddressesArray==undefined){
                        this.undefinedEmailAddressesArray.push(value)
                        
                    }
                    else{
                        this.emailAddressesArray.push(value)
                    }
               
                }
                if(array=="faxNumbers"){
                    if(this.faxNumbersArray==undefined){
                        let number = parseInt(value)
                       this.undefinedFaxNumbersArray.push(number) 
                    }
                    else{
                        this.faxNumbersArray.push(value)
                    }
                }if(array=="phoneNumbers"){
                      if(this.phoneNumbersArray==undefined){
                        let number = parseInt(value)
                       this.undefinedPhoneNumbersArray.push(number) 
                       
                    }
                    else{
                        this.phoneNumbersArray.push(value)
                    }
             
                }if(array=="gsmNumbers"){
                    if(this.gsmNumbersArray==undefined){
                        this.undefinedGsmNumbersArray.push(value) 
                    }
                    else{
                        this.gsmNumbersArray.push(value)
                    }
              
                }
             }
        },
 
       deleteItem(type,item){
        if(type=='emailAddresses'){
            for(var i in this.emailAddressesArray){
                if(item === this.emailAddressesArray[i]){
                this.emailAddressesArray.splice(i,1)
                }
            } 
        }
   
        else if(type=='phoneNumbers'){
            for(var i in this.phoneNumbersArray){
                if(item === this.phoneNumbersArray[i]){
                this.phoneNumbersArray.splice(i,1)
                }
            }
        }else if(type=='gsmNumbers'){
            for(var i in this.gsmNumbersArray){
                if(item === this.gsmNumbersArray[i]){
                this.gsmNumbersArray.splice(i,1)
                }
            }
        }else if(type=='faxNumbers'){
            for(var i in this.faxNumbersArray){
                if(item === this.faxNumbersArray[i]){
                this.faxNumbersArray.splice(i,1)
                }
            }
        }
       },
       deleteItemUn(type,item){
        if(type=='emailAddresses'){
            for(var i in this.undefinedEmailAddressesArray){
                if(item === this.undefinedEmailAddressesArray[i]){
                this.undefinedEmailAddressesArray.splice(i,1)
                }
            } 
        }
   
        else if(type=='phoneNumbers'){
            for(var i in this.undefinedPhoneNumbersArray){
                if(item === this.undefinedPhoneNumbersArray[i]){
                this.undefinedPhoneNumbersArray.splice(i,1)
                }
            }
        }else if(type=='gsmNumbers'){
            for(var i in this.undefinedGsmNumbersArray){
                if(item === this.undefinedGsmNumbersArray[i]){
                this.undefinedGsmNumbersArray.splice(i,1)
                }
            }
        }else if(type=='faxNumbers'){
            for(var i in this.undefinedFaxNumbersArray){
                if(item === this.undefinedFaxNumbersArray[i]){
                this.undefinedFaxNumbersArray.splice(i,1)
                }
            }
        }
       },
        saveButton(){
            let dataObj={} 
            let obj={}
            let url=""

            if(this.isEditMode==false){
                for (var customId in this.returnCustomField){
                    if (typeof this.returnCustomField[customId] !== 'function') {
                        obj[customId] = this.returnCustomField[customId]
                    }
                }

            }
                
            if(this.setContact["n"]==="" || this.setContact["n"]===undefined){
                this.$notify({ group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('NAME_CANNOT_BE_BLANK'),
                    text: this.$ml.get('PLEASE_ENTER_A_NAME')
                })
                setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
                return false
            }

            // if(this.setContact["sn"]===undefined){
            //     this.$notify({ group: 'foo',
            //         type: 'warn', 
            //         title: this.$ml.get('SURNAME_CANNOT_BE_EMPTY'),
            //         text: this.$ml.get('PLEASE_ENTER_A_SURNAME')
            //     })
            //     return false
            // }

            for (var k in this.setContact){
                if(this.customFieldArray.find(c=>c._id.$oid==k)===undefined){
                    obj[k]= this.setContact[k]
                }
                if (typeof this.setContact[k] !== 'function') {

                    
                    if(this.setContact[k]===""){
                        delete this.setContact[k]
                    }
                    

                    if(this.setContact["country"]==="0"){
                       delete this.setContact["country"]
                    }
                    if(this.setContact["city"]==="0"){
                       delete this.setContact["town"]
                    }
                    if(this.isEditMode===true){
                        delete this.setContact["cuid"]
                    }

                    
                }
                if(k=='gsm'){
                    var array = []
                    if(this.gsmNumbersArray!==undefined){
                        if(typeof(this.gsmNumbersArray)=='object'){
                            obj["gsm"] = this.gsmNumbersArray
                        }else{
                            array.push(this.gsmNumbersArray)
                            obj["gsm"] = array
                        }
                    }
                    else{
                        if(typeof(this.undefinedGsmNumbersArray)=='object'){
                            obj["gsm"] = this.undefinedGsmNumbersArray
    
                        }else{
                            array.push(this.undefinedGsmNumbersArray)
                            obj["gsm"] = array
                        }
                    }
                }
                if(k=='phone'){
                    var array = []
                     
                    if(this.phoneNumbersArray!==undefined){
                        if(typeof(this.phoneNumbersArray)=='object'){
                            obj["phone"] = this.phoneNumbersArray
                        }else{
                            array.push(this.phoneNumbersArray)
                            obj["phone"] = array
                        }
                    }
                    else{
                        if(typeof(this.undefinedPhoneNumbersArray)=='object'){
                            obj["phone"] = this.undefinedPhoneNumbersArray
    
                        }else{
                            array.push(this.undefinedPhoneNumbersArray)
                            obj["phone"] = array
                        }
                    }
                }
                if(k=='fax'){
                    var array = []
                    
                    if(this.faxNumbersArray!==undefined){
                        if(typeof(this.faxNumbersArray)=='object'){
                            obj["fax"] = this.faxNumbersArray
                        
                        }else{
                            array.push(this.faxNumbersArray)
                            obj["fax"] = array
                        }
                    }
                    else{
                        if(typeof(this.undefinedFaxNumbersArray)=='object'){
                            obj["fax"] = this.undefinedFaxNumbersArray
    
                        }else{
                            array.push(this.undefinedFaxNumbersArray)
                            obj["fax"] = array
                        }
                    }
                }
                if(k=='email'){
                    var array = []
                    if(this.emailAddressesArray!==undefined){
                        if(typeof(this.emailAddressesArray)=='object'){
                        obj["email"] = this.emailAddressesArray

                        }else{
                            array.push(this.emailAddressesArray)
                            obj["email"] = array
                        }
                    }
                    else{
                        if(typeof(this.undefinedEmailAddressesArray)=='object'){
                            obj["email"] = this.undefinedEmailAddressesArray
    
                        }else{
                            array.push(this.undefinedEmailAddressesArray)
                            obj["email"] = array
                        }
                    }
                }
            }

            if(this.country.length>0){
                obj["country"]=this.country
            }
            if(this.city.length>0){
                obj["city"]=this.city
            }

            if(this.setContact["town"]!==0){
               // this.setContact["town"]=String(this.setContact["town"])
            }

            if(this.organizationId!=="" && this.organizationId!==undefined){
                this.setContact['organization']={'$oid':this.organizationId}
                obj['organization']={'$oid':this.organizationId}
            }
            
            if(this.setContact["email"]!=="" && this.setContact["email"]!==undefined){
                if(!this.validEmail(this.setContact["email"])){
                    setTimeout(() => {
                        $(".crm-modal-body").css("display","block")
                        $(".crm-modal-header").css("position","sticky")
                        $(".crm-modal-footer").css("display","flex")
                        $(".crm-modal-content").css("width","100% ")
                    }, 300);
                    return false
                }
            }
            if( this.setContact["gsm"]!==undefined&&this.setContact["gsm"].length<10 || 
                this.setContact["phone"]!==undefined&&this.setContact["phone"].length<10 ||
                this.setContact["gsm"]!==undefined&&this.setContact["gsm"].length>12 || 
                this.setContact["phone"]!==undefined&&this.setContact["phone"].length>12
            ){
                this.$notify({ group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('PHONE_INVALID'),
                    text: this.$ml.get('PLEASE_ENTER_A_VALID_PHONE_NUMBER')
                })
                 setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
                }, 300);
                return false
            }


            if(this.setContact["dob"]!=="" && this.setContact["dob"]!==undefined){
                this.setContact["dob"]=this.$moment(this.setContact["dob"]).toISOString()
                this.setContact["dob"]={"$date":this.setContact["dob"]}
            }
            delete this.setContact["wed_ann"]
            delete this.setContact["dob"]
            /*
            if(this.setContact["wed_ann"]!=="" && this.setContact["wed_ann"]!==undefined){
                this.setContact["wed_ann"]=this.$moment(this.setContact["wed_ann"]).toISOString()
                this.setContact["wed_ann"]={"$date":this.setContact["wed_ann"]}
            }
            */
            if(this.isEditMode===false){
                url = "addContact"
                obj["customerFileIds"]=this.customerFiles.map(function(i){
                    return {$oid:i.$oid}
                })
                dataObj["contactInputObj"]=obj
                this.postContact(url,dataObj)
                this.customerFiles=[]
            }else{
                url = "updateContact"
                dataObj["objId"]=this.contactId
                // dataObj["updateObj"]=obj
               
                obj["customerFileIds"]=this.customerFiles.map(function(i){
                    return {$oid:i.$oid}
                })
                dataObj["updateObj"]=obj
                this.postContact(url,dataObj)
                this.customerFiles=[]
            }
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
        },

        changeAlertModalCancel(){
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
          
        },
        
        closeButton(){
            //  this.clear()
            // $("#add").modal("hide")
            // this.$emit('getContact')
            if(
               
                this.organizationKeyword=="" && 
                this.country=="" && 
                this.city=="" &&
                this.setContact['n']==undefined && 
                this.setContact['sn']==undefined &&
                this.setContact['tck']==undefined &&
                this.setContact['email']=="" &&
                this.setContact['gsm']=="" &&
                this.setContact['phone']=="" &&
                this.setContact['fax']==""  && 
                this.setContact['addr']==""
                )
                {
                  $("#add").modal("hide")
                  this.clear()    
                }
            else{
                $(".crm-modal-body").css("display","none")
                $(".crm-modal-header").css("position","absolute ")
                $(".crm-modal-footer").css("display","none ")
                $(".crm-modal-content").css("width","0 ")
                    $('#changeAlertModalContact').modal('show')
                    // this.clear() 
                }   
        },
        clear(){
            this.setContact={
                isCandidate:true,
                name:"",
                contacts:[],
                webAddr:"",
                addr:"",
                country:"",
                city:"",
                town:"",
                x:true,
                status:true,
                phone:"",
                gsm:"",
                email:"",
                fax:""
            },
            this.gsmNumbersArray=[],
            this.undefinedFaxNumbersArray=[],
            this.undefinedEmailAddressesArray=[],
            this.undefinedPhoneNumbersArray=[],
            this.undefinedGsmNumbersArray=[],
            this.phoneNumbersArray=[],
            this.faxNumbersArray=[],
            this.emailAddressesArray=[],
            this.contactId=""
            this.organizationKeyword=""
            this.organizationId=""
            this.returnCustomField=[]
            this.isHiddenOrganization=false
            this.items=[]
            this.organizations=[]
            this.country=""
            this.city=""
            //  this.setContact['email']='',
            //  this.setContact['gsm']='',
            //  this.setContact['phone']='',
            //  this.setContact['fax']=''
            setTimeout(() => {
            this.$refs.customFields.clearCustom();
            }, 1000);
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    if(this.isEditMode===false){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('NEW_CONTACT_ADDED'),
                            text: res.data.status.desc 
                        })
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('CONTACT_UPDATED'),
                            text: res.data.status.desc 
                        })

                    }
                    $('#add').modal('hide')
                    this.clear()
                    this.$store.state.editLine=[]
                    this.$emit('getData',res.data.content.contact)
                    this.$emit('updateList')
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        quickOrganization(){
             
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    this.isHiddenOrganization= true
                     
                }else{
                     
                }
            })
        },
        oldData(){
            this.dataFilling(this.data)

            
            
             if(typeof(this.data.email)=='string'){
              
                this.emailAddressesArray.push(this.data.email)
            }else{
                this.emailAddressesArray=this.data.email
            }
             if(typeof(this.data.fax)=='string'){
              
                this.faxNumbersArray.push(this.data.fax)
            }else{
                this.faxNumbersArray=this.data.fax
            }
             if(typeof(this.data.phone)=='string'){
              
                this.phoneNumbersArray.push(this.data.phone)
            }else{
                this.phoneNumbersArray=this.data.phone
            }
            if(typeof(this.data.gsm)=='string'){
              
                this.gsmNumbersArray.push(this.data.gsm)
            }else{
                this.gsmNumbersArray=this.data.gsm
            }
          
           this.setContact['gsm']='',
           this.setContact['email']='',
           this.setContact['phone']='',
           this.setContact['fax']=''

            
        },
        arrayToString(val){
            if(typeof(val)=='object'){
                return val[0]
            }else{
                return val
            }
        },
        dataFilling(updateData){
            this.clear()
            this.customFieldsData=updateData
            for (var key in updateData){
                if (typeof updateData[key] !== 'function') {
                        this.setContact[key]=this.arrayToString(updateData[key])
                }
            }
            if(!this.isEmpty(updateData)){
                if(updateData._id.$oid!==undefined){
                    this.contactId=updateData._id.$oid
                }
                if(this.setContact["country"]!==undefined){
                    this.country=this.setContact["country"]
                    if(this.country=="Turkey" || this.country=="Türkiye"){
                        this.isTurkeyCountry=true;
                    }else{       
                        this.isTurkeyCountry=false;
                    }
                }
                if(this.setContact["city"]!==undefined){
                    this.city=this.setContact["city"]
                }
                 
                
                if(typeof(this.setContact["organization"])=='object'){
                    this.setResult(this.setContact["organization"])
                }else if(this.setContact["organization"]!==undefined && this.setContact["organization"].length>0 && this.setContact["organization"][0]!=null){
                    this.setResult(this.setContact["organization"][0])
                }
            } 
        },
        isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        },
        changeCountry(val){
            if(val=="Turkey" || val=="Türkiye"){
                this.isTurkeyCountry=true;
            }else{       
                this.isTurkeyCountry=false;
            }
            this.setContact['country']=this.country
        },
        ...mapActions([
            'updateLoading'
        ]),
        activaTabContact(){
            // $('#newActivityTabMenu a[href="#' + "'activityA_'+parentComp" + '"]').tab('show');
            // activaTab("'activityA_'+parentComp")
            $('.mincrm-dynamic-tabs a[href="#' + 'contact' + '"]').tab('show');
        },
        addNewFile(event){
            // this.fileId=event
            this.customerFiles.unshift(event) 
        },
        showCustomerFile(event){
            this.customerFiles=event
        },
    },
    watch: {
        
        organizationKeyword: _.debounce(function() {
            this.addOrgArray['name']=this.organizationKeyword
            this.closeOrgButton()
            if(this.organizationKeyword.length===0){
                this.isHiddenOrganization=false
                this.organizationId=undefined
                this.items=[]
            } 
            if(this.selectOrganization!==this.organizationKeyword && this.organizationKeyword.length!==0){
                this.quickOrganization() 
            }
        }, 300),
        data(){
           this.dataFilling(this.data);
        

             if(typeof(this.data.email)=='string'){
              
                this.emailAddressesArray.push(this.data.email)
            }else{
                this.emailAddressesArray=this.data.email
            }
             if(typeof(this.data.fax)=='string'){
              
                this.faxNumbersArray.push(this.data.fax)
            }else{
                this.faxNumbersArray=this.data.fax
            }
             if(typeof(this.data.phone)=='string'){
              
                this.phoneNumbersArray.push(this.data.phone)
            }else{
                this.phoneNumbersArray=this.data.phone
            }
            if(typeof(this.data.gsm)=='string'){
              
                this.gsmNumbersArray.push(this.data.gsm)
            }else{
                this.gsmNumbersArray=this.data.gsm
            }
          
           this.setContact['gsm']='',
           this.setContact['email']='',
           this.setContact['phone']='',
           this.setContact['fax']=''
         
        },
        
        clearModal(val){
            if(!val){
                this.clear()
            }
        }
    },
    created(){
        this.customFieldsData=this.data
        // this.setInputData()
        this.$root.$refs.newContact=this
    },
    mounted(){
        $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
        
    },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-header{
    position: sticky;
    top: 0;
    z-index: 1;
}
label{
    margin-bottom: 4px;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


</style>